import { lazy } from "react";
import type { RouteObject } from "react-router";

const DashboardPage = lazy(() => import("./views/dashboard"));

const projectTableRoutes: RouteObject = {
  id: "project-table",
  path: "/project-table",
  element: <DashboardPage />,
};

export default projectTableRoutes;
